<script>
import CardItemNew from '@/views/app/CartECommerce/carrinho-compra/CardItemNew.vue';
import { mapGetters } from 'vuex';
import { formtPriceBr } from '@core/utils/filter';
import { generateRandomNumberOrder } from '@core/utils/utils';
import { BFormGroup, BOverlay } from 'bootstrap-vue';
import PedidoService from '@/services/Operacoes/SLSPedidos.service';
import Swal from 'sweetalert2';
import ToastificationContent from '@/@core/components/toastification/ToastificationContent.vue';
import { getParametro } from '@/utils/totvsApi';

const pedidoService = new PedidoService();
export default {
  name: 'Index',
  components: { BOverlay, BFormGroup, CardItemNew },
  data() {
    return {
      loading: false,
      todayISO: new Date().toISOString().split('T')[0],
    };
  },
  filters: {
    formtPriceBr,
  },
  computed: {
    ...mapGetters('PedidosStore', {
      items: 'getItemPedido',
      getTotalItensPedido: 'getTotalItensPedido',
    }),
    ...mapGetters('InfoPedido', [
      'GET_CLIENTE_DATA',
    ]),
    ...mapGetters('PicStore', {
      picSelected: 'GET_PIC_SELECTED',
    }),
    pedidoMinimo() {
      return this.$store.getters['PedidosStore/getTotalPedidoComImposto'] >= Number(this.GET_CLIENTE_DATA.valorMinimoPedido);
    },
    formInfoPedido: {
      get() {
        return this.$store.getters['InfoPedido/GET_FORM_INFO_PEDIDO'];
      },
      set(value) {
        this.$store.commit('InfoPedido/SET_FORM_INFO_PEDIDO', value);
      },
    },
    pedido: {
      get() {
        return this.$store.getters['PedidosStore/getPedido'];
      },
      set(value) {
        this.$store.commit('PedidosStore/SET_PEDIDO', value);
      },
    },
    pedidoItens: {
      get() {
        return this.$store.getters['PedidosStore/getItemPedido'];
      },
      set(value) {
        this.$store.commit('PedidosStore/SET_CART_ITEMS', value);
      },
    },
    dataEntregaPadrao() {
      const date = new Date();
      date.setDate(date.getDate() + 7);

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const br = `${day}/${month}/${year}`;
      console.debug('[Cart] dataEntregaPadrao computed ->', { base: new Date().toISOString(), plus7ISO: date.toISOString().split('T')[0], br });
      return br;
    },
    dataEntregaInput: {
      get() {
        const current = this.formInfoPedido?.dataPrevistaEntrega || this.dataEntregaPadrao;
        const iso = this.normalizeDateToISO(current);
        console.debug('[Cart] dataEntregaInput.get', { current, iso });
        return iso;
      },
      set(newISO) {
        if (!newISO) return;
        const todayISO = new Date().toISOString().split('T')[0];
        let isoToCommit = newISO.split('T')[0];
        if (isoToCommit < todayISO) {
          const d = new Date();
          d.setDate(d.getDate() + 7);
          isoToCommit = d.toISOString().split('T')[0];
          console.debug('[Cart] dataEntregaInput.set: past date detected, overriding to +7', { from: newISO, to: isoToCommit });
        }
        const [yyyy, mm, dd] = isoToCommit.split('-');
        const br = `${dd}/${mm}/${yyyy}`;
        console.debug('[Cart] dataEntregaInput.set', { newISO, commitISO: isoToCommit, commitBR: br });
        this.$store.commit('InfoPedido/SET_DATA_PREVISTA_ENTREGA', br);
      },
    },
  },
  methods: {
    ensureValidEntregaDateBR() {
      try {
        const currentBR = this.formInfoPedido?.dataPrevistaEntrega;
        const currentISO = this.normalizeDateToISO(currentBR);
        const todayISO = new Date().toISOString().split('T')[0];
        if (!currentISO || currentISO < todayISO) {
          const d = new Date();
          d.setDate(d.getDate() + 7);
          const iso = d.toISOString().split('T')[0];
          const [yyyy, mm, dd] = iso.split('-');
          const br = `${dd}/${mm}/${yyyy}`;
          console.debug('[Cart] ensureValidEntregaDateBR: fixing past/empty date', {
            prevBR: currentBR, prevISO: currentISO, commitISO: iso, commitBR: br,
          });
          this.$store.commit('InfoPedido/SET_DATA_PREVISTA_ENTREGA', br);
        } else {
          console.debug('[Cart] ensureValidEntregaDateBR: date OK', { currentISO });
        }
      } catch (e) {
        console.debug('[Cart] ensureValidEntregaDateBR: error', e);
      }
    },
    normalizeDateToISO(dateValue) {
      const todayISO = new Date().toISOString().split('T')[0];
      console.debug('[Cart] normalizeDateToISO: input', dateValue, 'todayISO', todayISO);
      if (!dateValue) {
        const d = new Date();
        d.setDate(d.getDate() + 7);
        const out = d.toISOString().split('T')[0];
        console.debug('[Cart] normalizeDateToISO: no input, returning', out);
        return out;
      }

      if (typeof dateValue === 'string') {
        if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateValue)) {
          const [dd, mm, yyyy] = dateValue.split('/');
          const out = `${yyyy}-${mm.padStart(2, '0')}-${dd.padStart(2, '0')}`;
          console.debug('[Cart] normalizeDateToISO: BR->ISO', { in: dateValue, out });
          return out;
        }
        if (/^\d{4}-\d{2}-\d{2}/.test(dateValue)) {
          const out = dateValue.split('T')[0];
          console.debug('[Cart] normalizeDateToISO: ISO passthrough', { in: dateValue, out });
          return out;
        }
      }

      try {
        const d = new Date(dateValue);
        if (!isNaN(d.getTime())) {
          const out = d.toISOString().split('T')[0];
          console.debug('[Cart] normalizeDateToISO: Date parsed', { in: dateValue, out });
          return out;
        }
      } catch (e) { /* noop */ }

      const d = new Date();
      d.setDate(d.getDate() + 7);
      const out = d.toISOString().split('T')[0];
      console.debug('[Cart] normalizeDateToISO: fallback', out);
      return out;
    },
    getActiveDraftId() {
      try {
        return localStorage.getItem('activeDraftId') || null;
      } catch (e) {
        return null;
      }
    },
    setActiveDraftId(id) {
      try {
        if (id) localStorage.setItem('activeDraftId', String(id));
      } catch (e) { /* noop */ }
    },
    updateDraftsIndex(meta) {
      try {
        const key = 'pedido_drafts_index';
        const raw = localStorage.getItem(key);
        const index = raw ? JSON.parse(raw) : [];
        const i = index.findIndex((d) => String(d.id) === String(meta.id));
        if (i >= 0) index[i] = { ...index[i], ...meta, updatedAt: new Date().toISOString() };
        else index.push({ ...meta, createdAt: new Date().toISOString(), updatedAt: new Date().toISOString() });
        localStorage.setItem(key, JSON.stringify(index));
      } catch (e) { /* noop */ }
    },
    removeDraftCompletely(draftId) {
      try {
        if (!draftId) return;
        localStorage.removeItem(`pedido_draft_${draftId}`);
        const key = 'pedido_drafts_index';
        const raw = localStorage.getItem(key);
        const index = raw ? JSON.parse(raw) : [];
        const filtered = index.filter((d) => String(d.id) !== String(draftId));
        localStorage.setItem(key, JSON.stringify(filtered));
        const active = this.getActiveDraftId();
        if (active && String(active) === String(draftId)) {
          localStorage.removeItem('activeDraftId');
        }
      } catch (e) { /* noop */ }
    },
    saveDraftSnapshot(draftId) {
      try {
        if (!draftId) return;
        const snapshot = {
          id: draftId,
          origem: 'carrinho',
          infoPedidoSnapshot: this.formInfoPedido,
          itens: this.pedidoItens,
          total: this.$store.getters['PedidosStore/getTotalPedido'],
        };
        localStorage.setItem(`pedido_draft_${draftId}`, JSON.stringify(snapshot));

        const clienteNome = this.formInfoPedido?.cliente?.clientenomeabreviado || this.GET_CLIENTE_DATA?.cliente?.clientenomeabreviado || '';
        const meta = {
          id: draftId,
          cliente: clienteNome,
          origem: 'carrinho',
          total: snapshot.total,
        };
        this.updateDraftsIndex(meta);
        this.setActiveDraftId(draftId);
      } catch (e) { /* noop */ }
    },
    loadActiveDraftIfAny() {
      try {
        const activeId = this.getActiveDraftId();
        if (!activeId) return;
        if (this.pedidoItens && this.pedidoItens.length > 0) return;
        const raw = localStorage.getItem(`pedido_draft_${activeId}`);
        if (!raw) {
          console.log('Rascunho não encontrado neste dispositivo. O rascunho ativo foi iniciado em outro dispositivo. Prosseguindo sem restauração.');
          return;
        }
        const draft = JSON.parse(raw);
        if (draft.infoPedidoSnapshot) {
          this.$store.commit('InfoPedido/SET_FORM_INFO_PEDIDO', draft.infoPedidoSnapshot);
          this.$root.$emit('info-pedido:updated', draft.infoPedidoSnapshot);
          this.ensureValidEntregaDateBR();
        }
        if (Array.isArray(draft.itens)) {
          this.$store.commit('PedidosStore/SET_CART_ITEMS', draft.itens);
        }
      } catch (e) { /* noop */ }
    },
    onInputCondicaoPagamento(value) {
      console.log('onInputCondicaoPagamento', value);
      this.pedido.condicaoPagamento = value;
    },
    onInputTipoPedidoCliente(value) {
      console.log('onInputTipoPedidoCliente', value);
      this.pedido.tipoPedidoCliente = value;
    },
    async finalizarRascunhoCart() {
      this.loading = true;
      try {
        const naturezaOperacaoImposto = this.pedidoItens.length > 0 && this.pedidoItens[0].naturezaoperacaoidimposto
          ? this.pedidoItens[0].naturezaoperacaoidimposto
          : this.formInfoPedido.naturezaOperacao?.naturezaoperacaoid || '';

        const dataEntregaISO = this.normalizeDateToISO(this.formInfoPedido.dataPrevistaEntrega || this.dataEntregaPadrao);

        const resPedido = await pedidoService.finalizarRascunhoCart({
          picid: this.picSelected?.picid || null,
          estabelecimentoid: this.formInfoPedido.estabelecimento.estabelecimentoid,
          representanteid: this.formInfoPedido.representante.representanteid,
          clienteid: this.formInfoPedido.cliente.clienteid,
          tipopedidoid: this.formInfoPedido.tipoPedido?.tipopedidoid || '',
          condicaopagamentoid: this.formInfoPedido.condicaoPagamento.condicaopagamentoid,
          tabelaprecoid: this.formInfoPedido.tabelaPreco.tabelapreco_id,
          pedidoobservacoes: this.formInfoPedido.observacao,
          pedidourgente: false,
          pedidodataentrega: dataEntregaISO,
          pedidodataentregaprevista: dataEntregaISO,
          pedidovalortotal: this.$store.getters['PedidosStore/getTotalPedido'],
          tipoenderecoid: this.formInfoPedido.enderecoEntrega.tipoenderecoid,
          pedidooccliente: this.formInfoPedido.numeroPedidoOrderCompra,
          pedidoconsumidorfinal: true,
          pedidoprioridade: this.formInfoPedido.prioridadesPedido,
          canalvendaid: this.formInfoPedido.canalVenda?.canal_venda_id || '',
          cod_priori: this.formInfoPedido.prioridadesPedido,
          naturezaoperacaoid: naturezaOperacaoImposto,
          itemsPedido: this.pedidoItens,
        });

        // Salva snapshot local por rascunho e marca como ativo
        const draftId = resPedido?.data?.data?.pedidoid;
        if (draftId) {
          this.saveDraftSnapshot(draftId);
        }

        // Aviso: integração com TOTVS pausada para testes
        const totvsFlag = await getParametro('INTEGRACAO_TOTVS');
        if (String(totvsFlag) === '0' && this.$toast) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Aviso',
              text: 'A integração com o TOTVS está pausada para período de testes.',
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          });
        }

        Swal.fire({
          title: 'Rascunho Salvo com Sucesso!',
          html: `Seu rascunho foi salvo com sucesso! Número do Rascunho: <strong>#${resPedido.data.data.pedidoid}</strong>`,
          icon: 'success',
          confirmButtonText: 'OK',
        }).then(() => {
          this.$store.dispatch('PedidosStore/clearPedidoAndItemPedido');
          this.$router.push({ name: 'home' });
        });
      } catch (error) {
        console.error('Erro ao finalizar pedido:', error);

        const errorMessage = error.message;

        if (errorMessage === 'ERRO_PEDIDO_NR_OC_CLIENTE_EXISTE') {
          Swal.fire({
            title: 'Erro ao finalizar pedido',
            text: 'O número da ordem de compra já existe. Por favor, utilize um número diferente.',
            icon: 'warning',
            confirmButtonText: 'OK',
          });
          return;
        }
        Swal.fire({
          title: 'Erro ao finalizar pedido',
          text: 'Ocorreu um erro ao processar seu pedido. Por favor, tente novamente mais tarde.',
          icon: 'warning',
          confirmButtonText: 'OK',
        });
      } finally {
        this.loading = false;
      }
    },
    async finalizarPedidoCart() {
      this.loading = true;
      try {
        const naturezaOperacaoImposto = this.pedidoItens.length > 0 && this.pedidoItens[0].naturezaoperacaoidimposto
          ? this.pedidoItens[0].naturezaoperacaoidimposto
          : this.formInfoPedido.naturezaOperacao?.naturezaoperacaoid || '';

        const dataEntregaISO = this.normalizeDateToISO(this.formInfoPedido.dataPrevistaEntrega || this.dataEntregaPadrao);

        const resPedido = await pedidoService.finalizarPedidoCart({
          picid: this.picSelected?.picid || null,
          estabelecimentoid: this.formInfoPedido.estabelecimento.estabelecimentoid,
          representanteid: this.formInfoPedido.representante.representanteid,
          clienteid: this.formInfoPedido.cliente.clienteid,
          tipopedidoid: this.formInfoPedido.tipoPedido?.tipopedidoid || '',
          condicaopagamentoid: this.formInfoPedido.condicaoPagamento.condicaopagamentoid,
          tabelaprecoid: this.formInfoPedido.tabelaPreco.tabelapreco_id,
          pedidoobservacoes: this.formInfoPedido.observacao,
          pedidourgente: false,
          pedidodataentrega: dataEntregaISO,
          pedidodataentregaprevista: dataEntregaISO,
          pedidovalortotal: this.$store.getters['PedidosStore/getTotalPedido'],
          tipoenderecoid: this.formInfoPedido.enderecoEntrega.tipoenderecoid,
          pedidooccliente: this.formInfoPedido.numeroPedidoOrderCompra,
          pedidoconsumidorfinal: true,
          pedidoprioridade: this.formInfoPedido.prioridadesPedido,
          canalvendaid: this.formInfoPedido.canalVenda?.canal_venda_id || '',
          cod_priori: this.formInfoPedido.prioridadesPedido,
          naturezaoperacaoid: naturezaOperacaoImposto,
          itemsPedido: this.pedidoItens,
        });

        // Se havia um rascunho ativo local, remove (pedido finalizado)
        const activeId = this.getActiveDraftId();
        if (activeId) {
          this.removeDraftCompletely(activeId);
        }

        // Aviso: integração com TOTVS pausada para testes
        const totvsFlag = await getParametro('INTEGRACAO_TOTVS');
        if (String(totvsFlag) === '0' && this.$toast) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Aviso',
              text: 'A integração com o TOTVS está pausada para período de testes.',
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          });
        }

        Swal.fire({
          title: 'Pedido Finalizado com Sucesso!',
          html: `Seu pedido foi finalizado com sucesso! Número do Pedido: <strong>#${resPedido.data.data.pedidoid}</strong>`,
          icon: 'success',
          confirmButtonText: 'OK',
        }).then(() => {
          this.$store.dispatch('PedidosStore/clearPedidoAndItemPedido');
          this.$router.push({ name: 'home' });
        });
      } catch (error) {
        console.error('Erro ao finalizar pedido:', error);

        const errorMessage = error.message;

        if (errorMessage === 'ERRO_PEDIDO_NR_OC_CLIENTE_EXISTE') {
          Swal.fire({
            title: 'Erro ao finalizar pedido',
            text: 'O número da ordem de compra já existe. Por favor, utilize um número diferente.',
            icon: 'warning',
            confirmButtonText: 'OK',
          });
          return;
        }
        Swal.fire({
          title: 'Erro ao finalizar pedido',
          text: 'Ocorreu um erro ao processar seu pedido. Por favor, tente novamente mais tarde.',
          icon: 'warning',
          confirmButtonText: 'OK',
        });
      } finally {
        this.loading = false;
      }
    },
    async handlerCancelarPedido() {
      Swal.fire({
        title: 'Cancelar Pedido',
        text: 'Deseja realmente cancelar o pedido?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store.dispatch('PedidosStore/clearPedidoAndItemPedido');
          this.$router.push({ name: 'home' });
        }
      });
    },
  },
  mounted() {
    try {
      console.debug('[Cart] Mounted: env', { NODE_ENV: process.env.NODE_ENV });
    } catch (e) { /* noop */ }

    if (this.getTotalItensPedido === 0) {
      this.$router.push({ name: 'home' });
    }

    if (!this.formInfoPedido.dataPrevistaEntrega) {
      console.debug('[Cart] No dataPrevistaEntrega found, committing default', { defaultBR: this.dataEntregaPadrao });
      this.$store.commit('InfoPedido/SET_DATA_PREVISTA_ENTREGA', this.dataEntregaPadrao);
    } else {
      console.debug('[Cart] Existing dataPrevistaEntrega', { value: this.formInfoPedido.dataPrevistaEntrega });
      this.ensureValidEntregaDateBR();
    }

    try {
      const activeId = this.getActiveDraftId();
      const draftsIndex = localStorage.getItem('pedido_drafts_index');
      console.debug('[Cart] Cache snapshot', { activeDraftId: activeId, draftsIndexLen: draftsIndex ? draftsIndex.length : 0 });
    } catch (e) { /* noop */ }

    // Tenta restaurar rascunho ativo (se existir) quando entrar no carrinho
    this.loadActiveDraftIfAny();
  },
};
</script>

<template>
  <b-overlay :show="loading" rounded="sm">
    <template #overlay>
      <div class="text-center">
        <b-spinner small class="mr-1"></b-spinner>
        <strong>
          Processando Pedido...
        </strong>
      </div>
    </template>
    <b-row class="position-relative">
      <b-col cols="12">
        <h1 class="cart-title">Carrinho de Compras</h1>
      </b-col>
      <b-col cols="12" md="8">
        <b-row>
          <b-col v-for="(item, index) in items" :key="`item-${item.item_id}-${index}`" cols="12"
            style="overflow-y: auto">
            <card-item-new :item="item" />
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="12" md="4">
        <b-card style="position: sticky;top: 70px;">
          <template #header>
            <h4 class="card-title">Resumo do Pedido</h4>
          </template>
          <b-form-group
            v-if="$store.getters['InfoPedido/GET_OPTIONS_TIPO_PEDIDO_CLIENTE'] && $store.getters['InfoPedido/GET_OPTIONS_TIPO_PEDIDO_CLIENTE'].length > 0"
            label="Tipo de Pedido" label-for="tipoPedido">
            <v-select id="tipoPedido" v-model="formInfoPedido.tipoPedidoCliente"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :clearable="false" label="tipopedidodescricao"
              :disabled="true" :options="$store.getters['InfoPedido/SET_TIPO_PEDIDO_CLIENTE']"
              @input="onInputTipoPedidoCliente" :reduce="option => option">
              <template #selected-option="{ tipopedidoid, tipopedidodescricao }">
                <div style="display: flex; align-items: baseline">
                  <strong>{{ tipopedidoid }} - {{ tipopedidodescricao }}</strong>
                </div>
              </template>
              <template #option="{ tipopedidoid, tipopedidodescricao }">
                <div class="d-flex align-items-center">
                  <span> {{ tipopedidoid }} - {{ tipopedidodescricao }}</span>
                </div>
              </template>
            </v-select>
          </b-form-group>
          <b-form-group label="Condição de Pagamento" label-for="codicaoPagamentoPedido">
            <v-select id="codicaoPagamentoPedido" v-model="formInfoPedido.condicaoPagamento"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :clearable="false" label="condicaopagamentodescricao"
              :disabled="true" :options="$store.getters['InfoPedido/GET_OPTIONS_CONDICAO_PAGAMENTO']"
              @input="onInputCondicaoPagamento" :reduce="option => option">
              <template #selected-option="{ condicaopagamentoid, condicaopagamentodescricao }">
                <div style="display: flex; align-items: baseline">
                  <strong>{{ condicaopagamentoid }} - {{ condicaopagamentodescricao }}</strong>
                </div>
              </template>
              <template #option="{ condicaopagamentoid, condicaopagamentodescricao }">
                <div class="d-flex align-items-center">
                  <span> {{ condicaopagamentoid }} - {{ condicaopagamentodescricao }}</span>
                </div>
              </template>
            </v-select>
          </b-form-group>
          <b-form-group label="Data Prevista de Entrega" label-for="dataPrevistaEntrega">
            <b-form-input
              id="dataPrevistaEntrega"
              type="date"
              v-model="dataEntregaInput"
              :min="todayISO"
            />
          </b-form-group>
          <b-card-text class="pt-1">
            <!-- <div class="d-flex justify-content-between">
            <span class="text-subtitle1 font-weight-bold">Total:</span>
            <span style="color: #3b5998;font-weight: bold">{{ $store.getters['PedidosStore/getTotalPedido'] | formtPriceBr }}</span>
          </div> -->
            <div class="d-flex justify-content-between">
              <span class="text-subtitle1 font-weight-bold">Total final:</span>
              <span style="color: #3b5998;font-weight: bold"> {{ $store.getters['PedidosStore/getTotalPedidoComImposto']
                |
                formtPriceBr }}</span>
            </div>
          </b-card-text>
          <div class="">
            <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="success"
                class="w-100"
                block
                @click="finalizarPedidoCart"
                :disabled="!pedidoMinimo"
            >
              <feather-icon icon="CheckCircleIcon" size="18" style="margin-right: 0.5rem;"/>
              Finalizar Compra
            </b-button>
             <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="danger"
                class="w-100"
                block
                @click="handlerCancelarPedido"
            >
              <feather-icon icon="XCircleIcon" size="18" style="margin-right: 0.5rem;"/>
              Cancelar Pedido
            </b-button>
            <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="warning"
                class="w-100"
                block
                :to="{ name: 'home' }"
            >
              <feather-icon icon="ShoppingCartIcon" size="18" style="margin-right: 0.5rem;"/>
              Continuar Comprando
            </b-button>
            <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="secondary"
                class="w-100"
                block
                @click="finalizarRascunhoCart"
            >
              <feather-icon icon="FileTextIcon" size="18" style="margin-right: 0.5rem;"/>
              Salvar Como Rascunho
            </b-button>
            <b-alert variant="warning" :show="!pedidoMinimo" class="mt-2">
              <div class="alert-body">
                <span>Pedido mínimo: R${{ this.GET_CLIENTE_DATA.valorMinimoPedido }}</span>
              </div>
            </b-alert>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<style scoped lang="scss">
.cart-title {
  color: var(--sf-surface-text-dark) !important;
}

// Sidebar card respects theme
.b-card {
  background: var(--sf-card-bg) !important;
  color: var(--sf-card-text) !important;
  border-color: var(--sf-card-border) !important;
}

// Form groups / inputs inside the sticky card
.form-group label {
  color: var(--sf-surface-muted) !important;
}

.form-control {
  background: var(--sf-form-bg) !important;
  color: var(--sf-form-text) !important;
  border-color: var(--sf-form-border) !important;
}
</style>
